import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useIntl } from "react-intl";
// depends on props.buttonstyle, button will display as primary, secondary, link or close button
export const EduIDButton = forwardRef((props, ref) => {
    var _a;
    const intl = useIntl();
    const extra = {};
    if (props.buttonstyle.includes("close")) {
        const closeLabel = intl.formatMessage({
            id: "eduIDButton.label",
            defaultMessage: "Close",
            description: "Notification modal close label",
        });
        extra["aria-label"] = closeLabel;
        extra["title"] = closeLabel;
    }
    return (_jsx("button", Object.assign({ ref: ref, type: props.type ? props.type : "button" }, extra, props, { buttonstyle: undefined, className: undefined, className: `${props.buttonstyle} ${(_a = props.className) !== null && _a !== void 0 ? _a : ""}`.trim(), children: props.children })));
});
EduIDButton.displayName = "EduIDButton";
